import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Interceramic_Title } from '../../../../../utils/EN/Modals/SpotsModals';

const ModalInterceramic2 = () => {
  return (
    <>
      <ModalVideo
        id="spot-interceramic2"
        dataText={Interceramic_Title}
        videoSrc="https://player.vimeo.com/video/731475156?h=71d6cd01d5&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_INTERCERAMIC2"
      />
    </>
  );
};

export default ModalInterceramic2;
